<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
      <!-- slides -->
      <swiper-slide v-for="(item, index) in bannerList" :key="index">
        <div class="banner">
          <img class="img" :src="baseUrl + (isMobile ? item.ImgSrc : item.PcImgSrc)" alt="" :index="index">
          <!-- <img class="img" :src="baseUrl +item.ImgSrc" alt="" :index="index"> -->
        </div>
      </swiper-slide>
      <!-- page -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>

</template>

<script>
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'banner',
  data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active',
        }
      }
    }
  },
  props: {
    bannerList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    callback() {

    }
  }
}
</script>

<style lang="less">
.swiper-pagination {
  .my-bullet {
    margin: 4px;
    background-color: rgba(255, 255, 255, 0.3);
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
  }

  .my-bullet-active {
    background-color: rgb(255, 255, 255);
  }
}

.banner {
  .img {
    width: 100%;
    max-height: 800px;
  }
}
</style>
